export const returnsHeadingLabel = 'returns.heading'
export const totalItemTextLabel = 'returns.item.list.totalItemText'
export const continueButtonLabel = 'returns.reasons.button.continue'
export const parcelPickupDateLabel = 'returns.parcel.date'
export const parcelPickupTextLabel = 'returns.parcel.pickup'
export const apiFailureMessageLabel = 'returns.api.failure'
export const returnsInfoHeadingTextLabel = 'returns.information.heading.text'
export const returnsInfoPoint1TextLabel = 'returns.information.point.1.text'
export const returnsInfoPoint2TextLabel = 'returns.information.point.2.text'
export const returnsInfoPoint3TextLabel = 'returns.information.point.3.text'

// Returns header
export const logoLabel = 'general.logo.label'
export const backButtonLabel = 'text.button.back'

// Returns registration
export const loginDescriptionLabel = 'returns.login.description'
export const loginButtonLabel = 'returns.login.button.register'
export const emailFieldLabel = 'RETURNSLOGIN.email.label.text'
export const orderNumberFieldLabel = 'RETURNSLOGIN.orderNumber.label.text'
export const emailMissingFieldErrorLabel = 'RETURNSLOGIN.email.error.missing.text'
export const orderMissingFieldErrorLabel = 'RETURNSLOGIN.orderNumber.error.missing.text'
export const orderNotFoundNotificationLabel = 'returns.registration.orderNotFound'
export const orderNotShippedNotificationLabel = 'returns.registration.orderNotShipped'
export const invalidWarehouseErrorMessage = 'returns.registration.invalidWarehouseErrorMessage'
export const invalidSessionNotification = 'returns.session.invalid'
export const returnNoteInformationLabel = 'returns.login.returnNote.reminder'

// Returns items list
export const noOfItemsToReturnLabel = 'returns.item.list.no.itemToReturn'
export const orderSummaryLabel = 'returns.item.list.orderSummary'
export const selectItemsToReturnLabel = 'returns.item.list.selectItemsToReturn'
export const previouslyReturnedLabel = 'returns.item.list.previouslyReturned'
export const orderInformationLabel = 'returns.item.list.orderInformation'
export const orderNumberLabel = 'returns.item.list.orderNumber'
export const orderDateLabel = 'returns.item.list.orderDate'
export const quantityOfTextLabel = 'returns.item.list.quantity.of.text'
export const colorTextLabel = 'returns.item.list.color.text'
export const sizeTextLabel = 'returns.item.list.size.text'
export const quantityTextLabel = 'returns.item.list.quantity.text'
export const totalTextLabel = 'returns.item.list.total.text'
export const returnsBadgeLabel = 'returns.item.list.badge.return'
export const returnInProgressLabel = 'returns.item.list.returnInProgress.text'
export const quantitySelectorLabel = 'returns.item.list.quantitySelector.label.text'
export const eInvoiceNumberLabel = 'returns.item.list.eInvoiceNumber'

// Returns reasons
export const reasonsHeadingLabel = 'returns.reasons.heading'
export const reasonsDescriptionLabel = 'returns.reasons.description'
export const quantityFormLabel = 'RETURNSREASONS.quantity.label.text'
export const commentsFormLabel = 'RETURNSREASONS.comments.label.text'

// Returns update modal
export const cancelMessageLabel = 'returns.item.list.popup.cancel.message'
export const editButtonLabel = 'returns.item.list.popup.edit.button'
export const cancelButtonLabel = 'returns.item.list.popup.cancel.button'

// Summary page
export const infoHeading = 'returns.summary.info.heading'
export const pickupHeadingLabel = 'returns.summary.return.method.heading'
export const pickupAddressLabel = 'returns.summary.pickup.address.heading'
export const dateHeadingLabel = 'returns.summary.pickup.date.heading'
export const pickupNoteLabel = 'returns.summary.pickup.date.note'
export const confirmButtonLabel = 'returns.summary.button.confirm'
export const returnsSummaryCancelButtonLabel = 'returns.summary.button.cancel'
export const customerConsentLabel = 'returns.summary.customer.consent'
export const customerConsentLinkLabel = 'returns.summary.customer.consent.link'
export const redirectToCarrierNoteLabel = 'returns.summary.redirect.to.carrier.note'
export const redirectToCarrierButtonLabel = 'returns.summary.redirect.to.carrier.button'

// drop off option
export const returnMethodDescription = 'returns.summary.return.method.description'
export const dropOffPoint = 'returns.summary.drop.off.name'

// Returnable parcels
export const returnsTextLabel = 'returns.summary.text'

// Returns pickup modal
export const editAddressLabel = 'returns.pickup.popup.heading'
export const saveButtonLabel = 'returns.pickup.popup.button.save.changes'
export const editPickupAddressButtonLabel = 'returns.pickup.edit.button'

// Pickup address edit form
export const pickupFirstNameFormLabel = 'RETURNSPICKUP.firstName.label.text'
export const pickupLastNameFormLabel = 'RETURNSPICKUP.lastName.label.text'
export const pickupAddressLine1FormLabel = 'RETURNSPICKUP.addressline1.label.text'
export const pickupAddressLine2FormLabel = 'RETURNSPICKUP.addressline2.label.text'
export const pickupProvinceFormLabel = 'RETURNSPICKUP.province.label.text'
export const pickupProvinceFieldPlaceholderLabel = 'RETURNSPICKUP.province.placeholder.text'
export const pickupTownFormLabel = 'RETURNSPICKUP.town.label.text'
export const pickupPostalcodeFormLabel = 'RETURNSPICKUP.postalcode.label.text'
export const pickupAddressLine1MissingFieldErrorLabel =
  'RETURNSPICKUP.addressline1.error.required.text'
export const pickupProvinceMissingFieldErrorLabel = 'RETURNSPICKUP.province.error.required.text'
export const pickupTownMissingFieldErrorLabel = 'RETURNSPICKUP.town.error.required.text'
export const pickupPostalcodeMissingFieldErrorLabel = 'RETURNSPICKUP.postalcode.error.required.text'
export const pickupAddressLine1InvalidFieldErrorLabel =
  'RETURNSPICKUP.addressline1.error.invalid.text'
export const pickupProvinceInvalidFieldErrorLabel = 'RETURNSPICKUP.province.error.invalid.text'
export const pickupTownInvalidFieldErrorLabel = 'RETURNSPICKUP.town.error.invalid.text'
export const pickupPostalcodeInvalidFieldErrorLabel = 'RETURNSPICKUP.postalcode.error.invalid.text'
export const pickupFirstNameMissingFieldErrorLabel = 'RETURNSPICKUP.firstName.error.required.text'
export const pickupFirstNameInvalidFieldErrorLabel = 'RETURNSPICKUP.firstName.error.invalid.text'
export const pickupLastNameMissingFieldErrorLabel = 'RETURNSPICKUP.lastName.error.required.text'
export const pickupLastNameInvalidFieldErrorLabel = 'RETURNSPICKUP.lastName.error.invalid.text'

// Confirmation page
export const confirmHeadingLabel = 'returns.confirm.heading'
export const confirmDescriptionLabel = 'returns.confirm.description'
export const confirmRefundHeadingLabel = 'returns.confirm.refund.heading'
export const refundNoteLabel = 'returns.confirm.refund.description'
export const subTotalLabel = 'returns.confirm.refund.subtotal'
export const shippingFeeLabel = 'returns.confirm.refund.shipping.fee'
export const taxesLabel = 'returns.confirm.refund.taxes'
export const refundTotalLabel = 'returns.confirm.refund.total'
export const refundedToLabel = 'returns.confirm.refunded.to'

// Notifications
export const codNotificationLabel = 'returns.notification.cod'

export const labelKeys = [
  returnsHeadingLabel,
  totalItemTextLabel,
  continueButtonLabel,
  parcelPickupDateLabel,
  parcelPickupTextLabel,
  logoLabel,
  backButtonLabel,
  loginDescriptionLabel,
  loginButtonLabel,
  orderNotFoundNotificationLabel,
  orderNotShippedNotificationLabel,
  invalidWarehouseErrorMessage,
  codNotificationLabel,
  emailMissingFieldErrorLabel,
  orderMissingFieldErrorLabel,
  emailFieldLabel,
  orderNumberFieldLabel,
  noOfItemsToReturnLabel,
  orderSummaryLabel,
  selectItemsToReturnLabel,
  previouslyReturnedLabel,
  orderInformationLabel,
  orderNumberLabel,
  eInvoiceNumberLabel,
  orderDateLabel,
  editAddressLabel,
  saveButtonLabel,
  editPickupAddressButtonLabel,
  apiFailureMessageLabel,
  infoHeading,
  pickupHeadingLabel,
  dateHeadingLabel,
  pickupAddressLabel,
  confirmButtonLabel,
  returnsSummaryCancelButtonLabel,
  customerConsentLabel,
  customerConsentLinkLabel,
  redirectToCarrierNoteLabel,
  redirectToCarrierButtonLabel,
  returnMethodDescription,
  dropOffPoint,
  pickupNoteLabel,
  cancelMessageLabel,
  editButtonLabel,
  cancelButtonLabel,
  confirmHeadingLabel,
  confirmDescriptionLabel,
  confirmRefundHeadingLabel,
  refundNoteLabel,
  quantityOfTextLabel,
  colorTextLabel,
  sizeTextLabel,
  quantityTextLabel,
  quantitySelectorLabel,
  totalTextLabel,
  returnsBadgeLabel,
  returnInProgressLabel,
  editAddressLabel,
  saveButtonLabel,
  editPickupAddressButtonLabel,
  reasonsHeadingLabel,
  reasonsDescriptionLabel,
  returnsTextLabel,
  subTotalLabel,
  shippingFeeLabel,
  taxesLabel,
  refundTotalLabel,
  refundedToLabel,
  quantityFormLabel,
  commentsFormLabel,
  pickupFirstNameFormLabel,
  pickupLastNameFormLabel,
  pickupAddressLine1FormLabel,
  pickupAddressLine2FormLabel,
  pickupPostalcodeFormLabel,
  pickupProvinceFormLabel,
  pickupProvinceFieldPlaceholderLabel,
  pickupTownFormLabel,
  pickupAddressLine1MissingFieldErrorLabel,
  pickupProvinceMissingFieldErrorLabel,
  pickupTownMissingFieldErrorLabel,
  pickupPostalcodeMissingFieldErrorLabel,
  pickupAddressLine1InvalidFieldErrorLabel,
  pickupProvinceInvalidFieldErrorLabel,
  pickupTownInvalidFieldErrorLabel,
  pickupPostalcodeInvalidFieldErrorLabel,
  invalidSessionNotification,
  pickupFirstNameMissingFieldErrorLabel,
  pickupFirstNameInvalidFieldErrorLabel,
  pickupLastNameMissingFieldErrorLabel,
  pickupLastNameInvalidFieldErrorLabel,
  returnsInfoHeadingTextLabel,
  returnsInfoPoint1TextLabel,
  returnsInfoPoint2TextLabel,
  returnsInfoPoint3TextLabel,
  returnNoteInformationLabel,
]
